import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Layout from "layout.js";
import Login from "views/Auth/Login";
import ForgotPassword from "views/Auth/ForgotPassword";
import ResetPassword from "views/Auth/ResetPassword";
import AccountSearch from "views/AccountSearch";
import NotFound from "./components/NotFound";
import Inbound from "./views/Inbound";
import Contacts from "./views/Contacts";
import Settings from "./views/Settings";
import { store } from "./Redux/store";
import { checkTokenExpiration } from "./components/functions/tokenUtils";
import {useSelector} from "react-redux";
import Directory from "./views/Directory";

export default function App() {
    const userRole = useSelector((state) => state.authReducer?.data?.role);
    const navigate = useNavigate();
    const location = useLocation();
    const tokenTime = store.getState().authReducer?.tokens?.access?.expires;
    const [intendedUrl, setIntendedUrl] = useState(null);
    useEffect(() => {
    },[])
    useEffect(() => {
        checkTokenExpiration(tokenTime);

        const role = localStorage.getItem("role");
        if (!role && location.pathname !== "/login" ) {
            setIntendedUrl(location.pathname);
            navigate("/login");
        }
    }, [tokenTime]);

    const role = localStorage.getItem("role");


    useEffect(() => {
        if (role && intendedUrl) {
            navigate(intendedUrl);
            setIntendedUrl(null);
        }
    }, [role, intendedUrl, navigate]);

    return (
        <Routes>
            {!role ? (
                <>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgotpassword" element={<ForgotPassword />} />
                    <Route path="/resetpassword" element={<ResetPassword />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </>
            ) : (
                <>
                    {userRole === "admin" && (
                        <>
                            <Route path="/account" element={<AccountSearch />} />
                        </>
                    )}
                    {
                        <>
                            <Route path="/login" element={<Navigate to={`/${userRole}/inbound`} replace />} />
                            <Route path="/" element={<Navigate to={`/${userRole}/inbound`} replace />} />
                            <Route path={`/${userRole}`} element={<Navigate to={`/${userRole}/inbound`} replace />} />
                            <Route path={`/${userRole}/inbound`} element={<Layout><Inbound /></Layout>} />
                            <Route path={`/${userRole}/inbound/message/:messageID`} element={<Layout><Inbound /></Layout>} />
                            <Route path={`/${userRole}/contacts`} element={<Layout><Contacts /></Layout>} />
                            <Route path={`/${userRole}/settings`} element={<Layout><Settings /></Layout>} />
                            <Route path={`/${userRole}/directory`} element={<Layout><Directory /></Layout>} />
                            <Route path={`/${userRole}/*`} element={<NotFound />} />
                            <Route path="*" element={<NotFound />} />
                        </>
                    }
                    <Route path="*" element={<NotFound />} />
                </>
            )}
        </Routes>
    );
}
